const PREVIEWABLE_IMAGE = new Set(["image/png", "image/jpeg", "image/gif", "image/webp", "image/bmp"]);

export function isPreviewable(mimeType: string): boolean {
  return PREVIEWABLE_IMAGE.has(mimeType) || mimeType === "application/pdf";
}

export function AttachmentPreview({
  filename,
  mimeType,
  url,
  onClose,
}: {
  filename: string;
  mimeType: string;
  url: string;
  onClose: () => void;
}) {
  return (
    <div className="gm-modal-scrim" style={{ zIndex: 50 }} onClick={onClose}>
      <div
        className="gm-modal gm-in"
        style={{ width: "min(900px, 90vw)", height: "85vh", display: "flex", flexDirection: "column" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="gm-settings-header">
          <div style={{ fontSize: 13, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{filename}</div>
          <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
            <a className="btn btn-ghost" href={url} download={filename}>
              Download
            </a>
            <button className="btn btn-ghost" onClick={onClose}>
              Esc
            </button>
          </div>
        </div>
        <div style={{ flex: 1, overflow: "auto", background: "var(--gm-bg-deep)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {PREVIEWABLE_IMAGE.has(mimeType) ? (
            <img src={url} alt={filename} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
          ) : (
            <iframe src={url} title={filename} style={{ width: "100%", height: "100%", border: "none" }} />
          )}
        </div>
      </div>
    </div>
  );
}
